import { object, string } from 'yup'

export const checkExcursionsValidate = object({
  departure_date: string().required(),
  direction: string().required(),
})
